<template>
    <div v-if="loadingSearchResults">
        <div class="loading-container">
            <span class="material-symbols-outlined spinning">sync</span>
            <div>LOADING AWESOME DEALS...</div>
        </div>
        <LoadMoreDeals  />       
    </div>    
    <div v-else>
        <div class="horizontal-scrollable-container" v-if="searchResults?.drilldownCategories?.length > 0">
            <div class="horizontal-scrollable-items">
                <div class="horizontal-scrollable-item" v-for="category in searchResults.drilldownCategories" :key="category.name" @click="navigateToCategory(category)">
                    {{ category.name }}
                </div>
            </div>
        </div>
        <div class="search-results-header">
            <span class="search-results-title">Results For </span>
            <span class="search-results-query">{{ $globalStore.searchQuery }}</span>
        </div>
        <div>
            <div>

                <Deals :listOfDeals="dealsList" :directLinks="true" :showPrice="true" />
                <!-- <div v-for="result in searchResults" :key="result.id">
                    <h2>{{ result.title }}</h2>
                    <p>{{ result.description }}</p>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { globalStore } from '@/stores/globalStore'
import api from '@/api'
import { ScrapeAmazonSearchResultsResult, ScrapedCategoryInfo, WebsiteProduct } from '@/classes/Search'
import { DealDetails } from '@/classes/DealDetails'
import util from '@/helpers/util'
import Deals from '@/components/Deals.vue'
import LoadMoreDeals from '@/components/LoadMoreDeals.vue'

const route = useRoute()
const router = useRouter()
const $globalStore = globalStore()
const loadingSearchResults = ref(false)
const searchResults = ref<ScrapeAmazonSearchResultsResult>()
const searchQuery = ref<string>('')
const dealsList = ref<DealDetails[]>([])

const navigateToCategory = async (category: ScrapedCategoryInfo) => {
    $globalStore.categoryNodes = category.nodes
    router.push({ name: 'search-results', query: { q: $globalStore.searchQuery, price: $globalStore.maxPrice, percent: $globalStore.minPercentOff, n: category.nodes.join(',') } })
    await init()
}

const init = async () => {
    if($globalStore.searchQuery) {
        searchQuery.value = $globalStore.searchQuery
    }

    else if(route.query.q) {
        searchQuery.value = route.query.q as string
        $globalStore.searchQuery = searchQuery.value
    }

    //CATEGORY NODES
    const categoryNodes = ref<string>('')
    if($globalStore.categoryNodes) {
        categoryNodes.value = $globalStore.categoryNodes.join(',')
    }
    else if(route.query.n) {
        categoryNodes.value = route.query.n as string
        $globalStore.categoryNodes = categoryNodes.value.split(',')
    }
    
    if(searchQuery.value) {

        console.log('SEARCH PARAMS', searchQuery.value, $globalStore.maxPrice, $globalStore.minPercentOff, categoryNodes.value);
        
        //SAVE IN LOCAL STORAGE
        localStorage.setItem('searchParams', JSON.stringify({
            searchQuery: searchQuery.value,
            maxPrice: $globalStore.maxPrice,
            minPercentOff: $globalStore.minPercentOff
        }));


        loadingSearchResults.value = true   
        const response = await api.getSearchResults(searchQuery.value, $globalStore.maxPrice, $globalStore.minPercentOff, categoryNodes.value)
        const scrapeAmazonSearchResultsResult = response.data as ScrapeAmazonSearchResultsResult;
        searchResults.value = scrapeAmazonSearchResultsResult;
        loadingSearchResults.value = false


        //FEED THE PRODUCTS INTO A DEAL DETAILS LIST
        let dealDetailsList: DealDetails[] = []
        //console.log('searchResults.value.data.products', searchResults.value.data.products)
        searchResults.value.products.forEach((product: WebsiteProduct) => {

            let dealDetails = new DealDetails({
                DealID: 0,
                Title: product.title,
                Description: '',
                ImgUrl: product.imgUrl,
                RetailPrice: product.retailPrice,
                DealPrice: product.salePrice,
                DealURL: 'https://www.amazon.com/dp/' + product.asin,
                DealProvider: 'Amazon',
                IsActive: false,
                IsArchived: false,
                InsertDate: new Date(),
                UpdateDate: new Date(),
                ProductID: product.asin,
                Tag: 'faf2',
                isExpired: false,
                PromoCode: '',
                isSoldOut: false,
                PrettyTitle: '',
                PrettyDesc: '',
            })

            //CALCULATE PERCENT OFF


            if(dealDetails.DealPrice == dealDetails.RetailPrice) 
            {
                dealDetails.RetailPrice = null;
            }

            const discount = util.getDiscountPercentage(dealDetails.DealPrice, dealDetails.RetailPrice);
            dealDetails.PercentOff = discount

            dealDetailsList.push(dealDetails)

        })
        

        //console.log('dealDetailsList', dealDetailsList)
        dealsList.value = dealDetailsList;

    }
}

onMounted(async () => {
    await init()
})  

</script>

<style scoped>
    .search-results-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 5px;
        background-color: #f0f0f0;
        

    }
    .search-results-title {
        font-size: 1em;
        font-weight: bold;
        margin-bottom: 5px;
        margin-top: 5px;
    }
    .search-results-query {
        font-size: 1em;
        margin-bottom: 10px;
        color: #909090;
        font-style: italic;
    }

    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 20px;
    }

    .spinning {
        animation: spin 1s linear infinite;
        font-size: 2em;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(-360deg);
        }
    }

</style>
